import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FiltroAntiguedadSaldos;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGenerar: () => Promise<void>;
}

/**
* Componente para editar un Entity
*/
export class AntiguedadSaldosFormNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
        };
    }


    render() {
        const { value, onGenerar } = this.props;
        const getField = this.getField;

        const Sucursal = getField(selectores.Sucursal);
        const Cliente = getField(selectores.Cliente);
        const Vendedor = getField(selectores.Vendedor);

        return (
            <div>
                <kea.Title titulo="Antigüedad de saldos" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <Sucursal field="IdSucursalCobranza" label="Sucursal de cobranza:" />,
                    <Cliente field="IdCliente" label="Cliente:" />,
                    <Vendedor field="IdVendedor" label="Vendedor:" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Genrar reporte" onClick={onGenerar} style="success" />
                    </div>
                </div>
            </div>);
    }
}

export const AntiguedadSaldos = componentToRx(AntiguedadSaldosFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteestadodecuenta/edit/form.tsx